import { render, staticRenderFns } from "./sift.vue?vue&type=template&id=29c58423&scoped=true"
import script from "./sift.vue?vue&type=script&lang=js"
export * from "./sift.vue?vue&type=script&lang=js"
import style0 from "./sift.vue?vue&type=style&index=0&id=29c58423&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c58423",
  null
  
)

export default component.exports